import { IconProps } from "@/common/contracts/icon.contracts";

export const MedalFilled = (props: IconProps) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_6070_13485)">
        <path
          d="M20 2.40259H4V4.40259L9.81 8.76259C6.14 9.97259 4.14 13.9326 5.35 17.6026C6.56 21.2726 10.5 23.2726 14.19 22.0626C17.86 20.8526 19.86 16.9026 18.65 13.2226C17.95 11.1126 16.3 9.45259 14.19 8.76259L20 4.40259V2.40259ZM14.94 19.9026L12 18.1826L9.06 19.9026L9.84 16.5726L7.25 14.3326L10.66 14.0426L12 10.9026L13.34 14.0426L16.75 14.3326L14.16 16.5726L14.94 19.9026Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_6070_13485">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.402588)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
